export const POOL_COLUMNS = [
  { id: 'name', label: 'Public Pool', width: 210, grow: true },
  { id: 'operator', label: 'Operator', width: 168, grow: false },
  { id: 'fee', label: 'Fee', width: 72, grow: true },
  { id: 'apr', label: 'APR', width: 88, grow: true },
  { id: 'sharpe', label: 'Sharpe Ratio', width: 100, grow: true },
  { id: 'tvl', label: 'TVL', width: 116, grow: true },
  { id: 'age', label: 'Age (days)', width: 100, grow: true },
  { id: 'yourDeposit', label: 'Your Deposits', width: 104, grow: true },
  { id: 'yourEquity', label: 'Your Equity', width: 104, grow: true },
]

export const ROW_HEIGHT = 52
export const HEADER_HEIGHT = 36
export const FOOTER_HEIGHT = 8

export function formatPoolFee(feePct) {
  if (!Number.isFinite(feePct)) return '-'
  const rounded = Math.round(feePct)
  return `${rounded}%`
}

export function formatPoolApr(apr) {
  if (apr == null || !Number.isFinite(apr)) return '0.00%'
  return `${apr.toFixed(2)}%`
}

export function formatPoolSharpe(sharpe) {
  if (sharpe == null || !Number.isFinite(sharpe)) return '-'
  return sharpe.toFixed(2)
}

export function formatPoolAge(ageDays) {
  if (ageDays == null || !Number.isFinite(ageDays)) return '-'
  return String(ageDays)
}

export function signedClass(value) {
  if (value == null || !Number.isFinite(value) || value === 0) return ''
  return value > 0 ? 'text-up' : 'text-down'
}

export function sortPools(pools, { key = 'tvl', direction = 'desc' } = {}) {
  const dir = direction === 'asc' ? 1 : -1
  return [...pools].sort((a, b) => {
    const av = sortValue(a, key)
    const bv = sortValue(b, key)
    if (av === bv) return 0
    if (av == null) return 1
    if (bv == null) return -1
    if (typeof av === 'string' && typeof bv === 'string') {
      return av.localeCompare(bv) * dir
    }
    return (av < bv ? -1 : 1) * dir
  })
}

function sortValue(pool, key) {
  switch (key) {
    case 'name':
      return pool.name?.toLowerCase() ?? ''
    case 'operator':
      return pool.operatorLabel?.toLowerCase() ?? ''
    case 'fee':
      return pool.fee
    case 'apr':
      return pool.apr
    case 'sharpe':
      return pool.sharpe
    case 'tvl':
      return pool.tvl
    case 'age':
      return pool.ageDays
    case 'yourDeposit':
      return pool.yourDeposit
    case 'yourEquity':
      return pool.yourEquity
    default:
      return pool.tvl
  }
}
